/**
 * @file HealthComponent.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import "./../notfound/PageNotFound.css"
import Typography from "@mui/material/Typography";
import { NotFoundTitleTheme } from "../notfound/NotFoundTheme";
import { BaseComponent } from "../home/base/BaseComponent";
import { BaseProps } from "../home/base/BaseProps";

/**
 * A class definition for HealthComponent
 */
export class HealthComponent extends BaseComponent<BaseProps, {}> { // eslint-disable-line

   componentDidMount() {
      this.logger.verbose("HealthComponent initialized", "HealthComponent");
   }

   render() {
      return <>
         <div className="NotPageFoundBox">
            <ThemeProvider theme={NotFoundTitleTheme}>
               <Typography>App is healthy.</Typography>
            </ThemeProvider>
         </div>
      </>
   }

}

export default HealthComponent;